/**
@format
@flow
*/
import * as React from 'react';
import { Heading as KrispyHeading } from '@krispy/typography/web';
import Colors from '@ziynx/theme/colors';
import headingConfig from './headingConfig';

type Props = $ReadOnly<{|
   /**
   * Large font size
   */
  large?: boolean,

  /**
   * Medium font size
   */
  medium?: boolean,

  /**
   * Small font size
   */
  small?: boolean,

  /**
   * Color for body text
   */
  color?: string,

  /**
   * Primitive types
   */
  primitive?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',

  /**
   * Text
   */
  children: any,
|}>;

/**
 * Heading component
 */
const Heading = (props: Props): React$Node => {
  const {
    children, color, ...rest
  } = props;
  return (
    <KrispyHeading
      {...rest}
      color={color}
      config={headingConfig}
    >
      {children}
    </KrispyHeading>
  );
};

Heading.defaultProps = {
  color: Colors.GrayVeryDark,
  primitive: 'h3',
};

export default Heading;
